import { message } from 'antd';
import call from '../../services/api';
import { goToLink } from '../../services/authService';
import { API_DONE, LOADING, LOGGING, LOGIN_FAILED, SMSSENDING, SMSSENT, START, TOKENREFRESHED } from './Auth.actions';

export default class AuthModel {

    public static start(){
        return async (dispatch: any, getState: any) => {
            dispatch({
                type: START
            });
        }
    }

    public static loginAction(username: string, password: string) {
        return async (dispatch: any, getState: any) => {
            dispatch({
                type: LOGGING
            });
            let result = null;
            try {
                result = await call(
                    {
                    path: '/api_login',
                    method: 'POST',
                    data: {
                        email: username,
                        password,
                    }
                });
                if (result && result?.error) {
                    dispatch({
                        type: LOGIN_FAILED,
                    });
                } else if (result&&result?.result) {
                    dispatch({
                        type: API_DONE
                    });
                }else{
                    return result
                }
                return result
            } catch (error: any) {
                dispatch({
                    type: LOGIN_FAILED,
                });
                return result?.error
            }
        };
    }

    public static requestSMSCodeAction(phone: string){
        return async (dispatch: any, getState: any) => {
            dispatch({
                type: SMSSENDING
            });
            let result = null;
            try {
                result = await call(
                    {
                    path: '/rpc',
                    method: 'POST',
                    data: {
                        jsonrpc: "2.0",
                        method: "profile.send_sms_login_code",
                        id: Math.floor(Math.random()*1000000),
                        params: {
                            phone,
                        }
                    }
                });
                return result
            } catch (error: any) {
                dispatch({
                    type: SMSSENT,
                });
                return result?.error
            }
        };
    }

    public static loginWithSMSCodeAction(sms: number, token: string){
        return async (dispatch: any, getState: any) => {
            dispatch({
                type: LOGGING
            });
            let result = null;
            try {
                result = await call(
                    {
                    path: '/rpc',
                    method: 'POST',
                    data: {
                        jsonrpc: "2.0",
                        method: "profile.login",
                        id: Math.floor(Math.random()*1000000),
                        params: {
                            smsCode: sms,
                            token,
                        }
                    }
                });
                dispatch({
                    type: API_DONE,
                });
                return result
            } catch (error: any) {
                dispatch({
                    type: LOGIN_FAILED,
                });
                return result?.error
            }
        };
    }

}
